


















import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import { InsertFollowPlan, UpdateFollowPlan } from "@/api/follow/followPlan";
import { GetListByCode } from "@/api/configureDictionary";
@Component({})
export default class FollowPlanAdd extends AbpBase {
  @Prop() data: any;
  dicPatientType: any = [];
  selectedTypes: any = [];
  model: any = {};
  rules = {
    name: [{ required: true, message: "请输入内容", trigger: "blur" }],
    content: [{ required: true, message: "请输入内容", trigger: "blur" }]
  };

  @Watch("data", { immediate: true })
  onDataChanged() {
    this.model = Object.assign({}, this.data);
    if (this.model.followPlanSourceList) {
      this.selectedTypes = [];
      this.model.followPlanSourceList.forEach(item => {
        this.selectedTypes.push(item.type);
      });
    }
  }

  resetForm() {
    this.$refs.form.resetFields();
  }

  async submit() {
    let validResult = false;
    this.$refs["form"].validate(valid => {
      if (valid) {
        validResult = true;
      }
    });
    if (validResult) {
      this.model.followPlanSourceList = [];
      this.selectedTypes.forEach(item => {
        this.model.followPlanSourceList.push({ type: item });
      });
      if (this.model.id) {
        await UpdateFollowPlan(this.model);
      } else {
        await InsertFollowPlan(this.model);
      }
      return true;
    }

    return false;
  }

  async initDic() {
    let res = await GetListByCode({ input: "PD_Patient_Type" });
    this.dicPatientType = res;
  }

  created() {
    this.initDic();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/follow/followPlan/planAdd.vue